
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/travel",
      function () {
        return require("private-next-pages/travel.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/travel"])
      });
    }
  